import { render, staticRenderFns } from "./TelInput.vue?vue&type=template&id=535a2956&scoped=true&"
import script from "./TelInput.vue?vue&type=script&lang=js&"
export * from "./TelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a2956",
  null
  
)

export default component.exports